import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b133ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-card__avatar-container" }
const _hoisted_2 = { class: "text-caption text-grey-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass(["person-card", { 'person-card--selected': _ctx.selected }]),
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectable ? _ctx.$emit('toggle', _ctx.person) : _ctx.$emit('click', _ctx.person)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.selectable)
          ? (_openBlock(), _createBlock(_component_q_checkbox, {
              key: 0,
              "model-value": _ctx.selected,
              class: "person-card__checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle', _ctx.person))),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["model-value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_q_avatar, {
          size: "100px",
          color: "grey-3",
          "text-color": "grey-6",
          class: "person-card__avatar"
        }, {
          default: _withCtx(() => [
            (_ctx.person.primaryFace && _ctx.person.primaryFace.imageUrl)
              ? (_openBlock(), _createBlock(_component_q_img, {
                  key: 0,
                  src: _ctx.person.primaryFace.imageUrl,
                  ratio: 1,
                  fit: "cover"
                }, {
                  error: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "fa fa-user-circle",
                      size: "40px"
                    })
                  ]),
                  _: 1
                }, 8, ["src"]))
              : (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  name: "fa fa-user-circle",
                  size: "40px"
                }))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_q_card_section, { class: "q-pa-sm text-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-body2 ellipsis", _ctx.person.label ? 'text-weight-medium' : 'text-grey-5 text-italic'])
          }, [
            _createTextVNode(_toDisplayString(_ctx.person.label || 'Unnamed Person') + " ", 1),
            _createVNode(_component_q_tooltip, { delay: 400 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.person.label || 'Unnamed Person'), 1)
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", _hoisted_2, " Occurrences: " + _toDisplayString(_ctx.facesCount), 1)
        ]),
        _: 1
      }),
      (!_ctx.selectable && _ctx.isGranted('MANAGE_PERSONS'))
        ? (_openBlock(), _createBlock(_component_q_card_actions, {
            key: 0,
            class: "q-pa-xs q-pt-none justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                size: "sm",
                icon: "fa fa-edit",
                color: "grey",
                flat: "",
                dense: "",
                round: "",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('edit', _ctx.person)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Edit")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                size: "sm",
                icon: "fa fa-trash",
                color: "negative",
                flat: "",
                dense: "",
                round: "",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('trash', _ctx.person)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Trash")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}